import PropTypes from 'prop-types';
import {
  Children,
  createRef,
  isValidElement,
  useEffect,
  useState,
} from 'react';
import styles from './FloatingActionMenu.module.css';

const MainButtons = ({ children }) => {
  return children;
};
const SubMenuButtons = ({ children }) => {
  return children;
};

const FloatingActionMenu = ({
  openSubMenuOnHover = false,
  fillWidth = false,
  children,
}) => {
  const [isFloating, setIsFloating] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const divRef = createRef();

  useEffect(() => {
    const cachedRef = divRef.current;
    const observer = new IntersectionObserver(
      ([e]) => {
        setIsFloating(e.intersectionRatio < 1);
      },
      { threshold: [1] },
    );
    observer.observe(cachedRef);
    return () => observer.unobserve(cachedRef);
  }, [divRef]);

  let mainButtons = [];
  let subMenuButtons = [];

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;
    if (child.type === MainButtons) {
      mainButtons.push(child);
    } else if (child.type === SubMenuButtons) {
      subMenuButtons.push(child);
    }
  });

  let numberMainButtons = mainButtons.length;
  let subMenuOpen = subMenuButtons.length > 0 && isExpanded;

  return (
    <>
      <div ref={divRef} style={{ position: 'relative' }} />
      <div
        className={
          fillWidth
            ? styles.main_button_container_full_width
            : styles.main_button_container
        }
        style={{ height: numberMainButtons * 46 }}>
        {/*Main Button(s)*/}
        <div
          className={`${styles.floating_action_box} ${
            !isFloating ? styles.not_floating_box : ''
          }`}
          onMouseOver={
            openSubMenuOnHover ? () => setIsExpanded(true) : undefined
          }
          onClick={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
          style={{
            opacity: subMenuOpen ? '0' : '1',
            visibility: subMenuOpen ? 'hidden' : 'visible',
            pointerEvents: subMenuOpen ? 'none' : 'auto',
          }}>
          {mainButtons}
        </div>

        {/*SubMenu*/}
        <div
          className={styles.floating_action_box}
          onMouseOver={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
          style={{
            opacity: subMenuOpen ? '1' : '0',
            visibility: subMenuOpen ? 'visible' : 'hidden',
            pointerEvents: subMenuOpen ? 'auto' : 'none',
          }}>
          {subMenuButtons}
        </div>
      </div>
    </>
  );
};

FloatingActionMenu.MainButtons = MainButtons;
FloatingActionMenu.MainButton = MainButtons;
FloatingActionMenu.SubMenuButtons = SubMenuButtons;

FloatingActionMenu.propTypes = {
  openSubMenuOnHover: PropTypes.bool,
  fillWidth: PropTypes.bool,
  children: PropTypes.node,
};

export default FloatingActionMenu;
